import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommunicationServiceProvider } from '../communication-service/communication-service';


@Injectable()
export class DataServiceProvider {
  ProposalTable: any = {
    "projectScreen": {
      "projectService": {
        "Hourly": [{
          "description": "",
          "hours": "",
          "total": ""
        }, {
          "description": "",
          "hours": "",
          "total": ""
        }],
        "FlatFree": [{
          "description": "",
          "total": ""
        }, {
          "description": "",
          "total": ""
        }],
        "courtesyDiscount": "",
        "TotalProjectService": ""
      },
      "Hslw": {
        "markup": "20%",
        "totalHslw": "",
        "hslwTable": [{
          "qty": "",
          "description": "",
          "unitCost": "",
          "orMarkup": "",
          "unitPrice": "",
          "extendedPrice": ""
        }, {
          "qty": "",
          "description": "",
          "unitCost": "",
          "orMarkup": "",
          "unitPrice": "",
          "extendedPrice": ""
        }, {
          "qty": "",
          "description": "",
          "unitCost": "",
          "orMarkup": "",
          "unitPrice": "",
          "extendedPrice": ""
        }, {
          "qty": "",
          "description": "",
          "unitCost": "",
          "orMarkup": "",
          "unitPrice": "",
          "extendedPrice": ""
        }, {
          "qty": "",
          "description": "",
          "unitCost": "",
          "orMarkup": "",
          "unitPrice": "",
          "extendedPrice": ""
        }]
      }
    },
    "hwswHaasSaasSheet": {
      "markUp": "25%",
      "TotalExtendedPrice": "",
      "ProductProfit": "",
      "TotalLeastCost": "",
      "TotalLeaseProfit": "",
      "TotalMonthlyLeaseAmt": "",
      "interestProfit": "",
      "interestPercent": "",
      "profitPercent": "",
      "Months": "24",
      "firstInvDate": "",
      "lastInvDate": "",
      "interestRate": "6%",
      "firstLastMnthPmt": "",
      "TotalLeaseRevenue": "",
      "contractLineItems": [{
        "qty": "",
        "description": "",
        "unitCost": "",
        "orMarkup": "",
        "unitPrice": "",
        "extendedPrice": "",
        "monthlyLeaseAmt": "",
        "totalLeaseRevenue": "",
        "totalLeaseCost": "",
        "totalLeaseProfit": ""
      }, {
        "qty": "",
        "description": "",
        "unitCost": "",
        "orMarkup": "",
        "unitPrice": "",
        "extendedPrice": "",
        "monthlyLeaseAmt": "",
        "totalLeaseRevenue": "",
        "totalLeaseCost": "",
        "totalLeaseProfit": ""
      }, {
        "qty": "",
        "description": "",
        "unitCost": "",
        "orMarkup": "",
        "unitPrice": "",
        "extendedPrice": "",
        "monthlyLeaseAmt": "",
        "totalLeaseRevenue": "",
        "totalLeaseCost": "",
        "totalLeaseProfit": ""
      }, {
        "qty": "",
        "description": "",
        "unitCost": "",
        "orMarkup": "",
        "unitPrice": "",
        "extendedPrice": "",
        "monthlyLeaseAmt": "",
        "totalLeaseRevenue": "",
        "totalLeaseCost": "",
        "totalLeaseProfit": ""
      }, {
        "qty": "",
        "description": "",
        "unitCost": "",
        "orMarkup": "",
        "unitPrice": "",
        "extendedPrice": "",
        "monthlyLeaseAmt": "",
        "totalLeaseRevenue": "",
        "totalLeaseCost": "",
        "totalLeaseProfit": ""
      }, {
        "qty": "",
        "description": "",
        "unitCost": "",
        "orMarkup": "",
        "unitPrice": "",
        "extendedPrice": "",
        "monthlyLeaseAmt": "",
        "totalLeaseRevenue": "",
        "totalLeaseCost": "",
        "totalLeaseProfit": ""
      }, {
        "qty": "",
        "description": "",
        "unitCost": "",
        "orMarkup": "",
        "unitPrice": "",
        "extendedPrice": "",
        "monthlyLeaseAmt": "",
        "totalLeaseRevenue": "",
        "totalLeaseCost": "",
        "totalLeaseProfit": ""
      }, {
        "qty": "",
        "description": "",
        "unitCost": "",
        "orMarkup": "",
        "unitPrice": "",
        "extendedPrice": "",
        "monthlyLeaseAmt": "",
        "totalLeaseRevenue": "",
        "totalLeaseCost": "",
        "totalLeaseProfit": ""
      }, {
        "qty": "",
        "description": "",
        "unitCost": "",
        "orMarkup": "",
        "unitPrice": "",
        "extendedPrice": "",
        "monthlyLeaseAmt": "",
        "totalLeaseRevenue": "",
        "totalLeaseCost": "",
        "totalLeaseProfit": ""
      }, {
        "qty": "",
        "description": "",
        "unitCost": "",
        "orMarkup": "",
        "unitPrice": "",
        "extendedPrice": "",
        "monthlyLeaseAmt": "",
        "totalLeaseRevenue": "",
        "totalLeaseCost": "",
        "totalLeaseProfit": ""
      }],
      "OfDuration": "",
      "nextMonth": "0",
      "leaseOrPurchase": "",
      "leaseOrPurchaseDescription": "For purchase of Hardware and software and related services (if applicable) as outlined in the table below."
    },
    "cloudPricingSheet": {
      "DiscountMonth": "",
      "startUpDescribe": "",
      "SetupConfigHours": '',
      "CourtesyDiscountHours": '',
      "SetupConfigOneTime": '',
      "CourtesyDiscountOneTime": '',
      "TotalStartUp": "",
      "FeesummaryMonthlyTotal": "",
      "AzureServices":{
        "AzureMarkup":"15.00%",
        "AzureTable":[]
      },
      "monthlyRecurring": {
        "monthlyPeriod": "",
        "cloudMonthlySelectedMonth": "",
        "cloudMonthlyTotalDiscount": "",
        "describe": "",
        "hours": "",
        "oneTime": "",
        "TotalBase": "",
        "TotalCpu": "",
        "TotalRam": "",
        "TotalDisk": "",
        "SubtotalIaaS": "",
        "SubTotalSaaS": "",
        "SubTotalMiscellaneous": "",
        "TotalMonthlyRecurring": "",
        "AzureServiceDescribe":"",
        "AzureQuote":"Y",
        "AzureSubTotal":"",
        "AzureTax":"",
        "AzureMonthly":"",
        "IaaS": [{
          "serverName": "",
          "base": "",
          "cpuQty": "",
          "cpuPrice": "",
          "cpuSubTtl": "",
          "ramQty": "",
          "ramPrice": "",
          "ramSubTtl": "",
          "diskQty": "",
          "diskPrice": "",
          "diskSubTtl": "",
          "Total": ""
        },
        {
          "serverName": "",
          "base": "",
          "cpuQty": "",
          "cpuPrice": "",
          "cpuSubTtl": "",
          "ramQty": "",
          "ramPrice": "",
          "ramSubTtl": "",
          "diskQty": "",
          "diskPrice": "",
          "diskSubTtl": "",
          "Total": ""
        },
        {
          "serverName": "",
          "base": "",
          "cpuQty": "",
          "cpuPrice": "",
          "cpuSubTtl": "",
          "ramQty": "",
          "ramPrice": "",
          "ramSubTtl": "",
          "diskQty": "",
          "diskPrice": "",
          "diskSubTtl": "",
          "Total": ""
        },
        {
          "serverName": "",
          "base": "",
          "cpuQty": "",
          "cpuPrice": "",
          "cpuSubTtl": "",
          "ramQty": "",
          "ramPrice": "",
          "ramSubTtl": "",
          "diskQty": "",
          "diskPrice": "",
          "diskSubTtl": "",
          "Total": ""
        },
        {
          "serverName": "",
          "base": "",
          "cpuQty": "",
          "cpuPrice": "",
          "cpuSubTtl": "",
          "ramQty": "",
          "ramPrice": "",
          "ramSubTtl": "",
          "diskQty": "",
          "diskPrice": "",
          "diskSubTtl": "",
          "Total": ""
        },
        {
          "serverName": "",
          "base": "",
          "cpuQty": "",
          "cpuPrice": "",
          "cpuSubTtl": "",
          "ramQty": "",
          "ramPrice": "",
          "ramSubTtl": "",
          "diskQty": "",
          "diskPrice": "",
          "diskSubTtl": "",
          "Total": ""
        },
        {
          "serverName": "",
          "base": "",
          "cpuQty": "",
          "cpuPrice": "",
          "cpuSubTtl": "",
          "ramQty": "",
          "ramPrice": "",
          "ramSubTtl": "",
          "diskQty": "",
          "diskPrice": "",
          "diskSubTtl": "",
          "Total": ""
        }, {
          "serverName": "",
          "base": "",
          "cpuQty": "",
          "cpuPrice": "",
          "cpuSubTtl": "",
          "ramQty": "",
          "ramPrice": "",
          "ramSubTtl": "",
          "diskQty": "",
          "diskPrice": "",
          "diskSubTtl": "",
          "Total": ""
        }],
        "SaaS": [{
          "item": "",
          "qty": "",
          "price": "",
          "total": ""
        },
        {
          "item": "",
          "qty": "",
          "price": "",
          "total": ""
        },
        {
          "item": "",
          "qty": "",
          "price": "",
          "total": ""
        },
        {
          "item": "",
          "qty": "",
          "price": "",
          "total": ""
        },
        {
          "item": "",
          "qty": "",
          "price": "",
          "total": ""
        },
        {
          "item": "",
          "qty": "",
          "price": "",
          "total": ""
        },
        {
          "item": "",
          "qty": "",
          "price": "",
          "total": ""
        }],
        "miscellaneous": [{
          "tools": "",
          "price": "",
          "description": ""
        },
        {
          "tools": "",
          "price": "",
          "description": ""
        },
        {
          "tools": "",
          "price": "",
          "description": ""
        },
        {
          "tools": "",
          "price": "",
          "description": ""
        },
        {
          "tools": "",
          "price": "",
          "description": ""
        }]
      }
    },
    "cyberPricingSheet": {
      "additionalDevices": "",
      "additionalUsers": "",
      "oneTimeFee": {
        "describeStartupFees": "",
        "SetupConfigHours": '',
        "CourtesyDiscountHours": '',
        "SetupConfigOneTime": '',
        "CourtesyDiscountOneTime": '',
        "TotalStartUp": "",
      },
      "subtotalCyberTools": {
        "subTotalUser": "",
        "subTotalDevice": "",
        "subTotalBaseFree": "",
        "subTotalTtlUser": "",
        "subTotalTtlDevice": "",
        "subTotalSubTotal": ""
      },
      "cyberTools": [{
        "id": "CyberWatch",
        "toolName": "CyberWatch",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "CyberLearn",
        "toolName": "CyberLearn",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "NetworkDetective",
        "toolName": "Network Detective",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "NetwrixAuditor",
        "toolName": "Netwrix Auditor",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      },
      {
        "id": "MDR",
        "toolName": " Managed Detection and Response -MDR",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "IdAgentDarkWeb",
        "toolName": "ID Agent Dark Web",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "PenTestTools",
        "toolName": "Pen Test Tools",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "CyberSuiteStandard",
        "toolName": "Cyber Suite Standard",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      },
      {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      },
      {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }],
      "additionalManagementTools": [{
        "id": "BfStandard",
        "toolName": "BitDefender - Standard",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "BfUltra",
        "toolName": "BitDefender - Ultra",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "AvananBasic",
        "toolName": "Avanan - Basic",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "AvananAdvanced",
        "toolName": "Avanan - Advanced",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      },
      {
        "id": "ConnectwiseThirdWall",
        "toolName": "Connectwise ThirdWall",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "Duo",
        "toolName": "Duo",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "Auvik",
        "toolName": "Auvik",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "InsuranceRecoveryFee",
        "toolName": "Insurance Recovery Fee",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }],
      "subtotalAdditionalManagementTools": {
        "subTotalUser": "",
        "subTotalDevice": "",
        "subTotalBaseFree": "",
        "subTotalTtlUser": "",
        "subTotalTtlDevice": "",
        "subTotalSubTotal": ""
      },
      "totalBackupDrMonthlyTool": "",
      "backupProdTotalDiscount": "",
      "monthlyPeriod": "",
      "backupProdSelectedMonth": "",
      "DiscountMonth": "",
    },
    "backupDrPricingSheet": {
      "BackupFeesummaryTotaly": "",
      "DiscountMonth": "",
      "totalBackupDrServiceOneTimeFees": "",
      "oneTimeFee": {
        "describeStartupFees": "",
        "SetupConfigHours": '',
        "CourtesyDiscountHours": '',
        "SetupConfigOneTime": '',
        "CourtesyDiscountOneTime": '',
        "subTotalStartUp": "",
        "describeDirectFees": ""
      },
      "mspBackupDr": {
        "noOfDattoDevices": 0,
        "noOfIntronisDevices": 0,
        "dattoDevicesAndPrice": '',
        "intronisDevicesAndPrice": '',
        "dattoOneTime": '',
        "dattoMonthly": '',
        "intronisOneTime": '',
        "intronisMonthly": '',
        "deviceCourtesyDiscountOneTime": '',
        "TotalBackupDrOneTime": '',
        "describe": '',
        "dattoIncl": '',
        "intronisIncl": '',
        "backupifyIncl": '',
        "backupifyMonthly": '',
        "deviceCourtesyDiscount": "",
        "dattoDevicesOnly": "",
        "intronisDevicesOnly": "",
        "backupifyDevicesOnly": ""
      },
      "backupTools": {
        "totalBackupDrMonthlyTool": "",
        "backupProdTotalPrice": "",
        "backupProdTotalDiscount": "",
        "monthlyPeriod": "",
        "totalBackupMonthlyPrice": "",
        "backupProdSelectedMonth": "",
        "backupProdTable": [{
          "backUpProdName": "pdt 1",
          "quantity": "",
          "price": "",
          "describe": "",
          "monthly": ""
        },
        {
          "backUpProdName": "pdt 2",
          "quantity": "",
          "price": "",
          "describe": "",
          "monthly": ""
        },
        {
          "backUpProdName": "pdt 3",
          "quantity": "",
          "price": "",
          "describe": "",
          "monthly": ""
        }]
      }
    },
    "mspPricingSheet": {
      "mspFeesummaryTotal": "",
      "DiscountMonth": "",
      "mspStartupFees": {
        "describe": "",
        "SetupConfigHours": '',
        "CourtesyDiscountHours": '',
        "SetupConfigOneTime": '',
        "CourtesyDiscountOneTime": '',
        "subTotalStartUp": ""
      },
      "mspBackupDr": {
        "noOfDattoDevices": 0,
        "noOfIntronisDevices": 0,
        "dattoDevicesAndPrice": '',
        "intronisDevicesAndPrice": '',
        "dattoOneTime": '',
        "dattoMonthly": '',
        "intronisOneTime": '',
        "intronisMonthly": '',
        "deviceCourtesyDiscountOneTime": '',
        "TotalBackupDrOneTime": '',
        "describe": '',
        "dattoIncl": '',
        "intronisIncl": '',
        "backupifyIncl": '',
        "backupifyMonthly": '',
        "deviceCourtesyDiscount": "",
        "dattoDevicesOnly": "",
        "intronisDevicesOnly": "",
        "backupifyDevicesOnly": ""
      },
      "miscProductService": {
        "describe": "",
        "miscProductTable": [{
          "miscOneTimeFee": '',
          "qtyAndAmt": '',
          "rateAndPrice": '',
          "oneTime": '',
        }, {
          "miscOneTimeFee": '',
          "qtyAndAmt": '',
          "rateAndPrice": '',
          "oneTime": '',
        }, {
          "miscOneTimeFee": '',
          "qtyAndAmt": '',
          "rateAndPrice": '',
          "oneTime": '',
        }, {
          "miscOneTimeFee": '',
          "qtyAndAmt": '',
          "rateAndPrice": '',
          "oneTime": '',
        }, {
          "miscOneTimeFee": '',
          "qtyAndAmt": '',
          "rateAndPrice": '',
          "oneTime": '',
        }],
        "subTotalMiscOneTime": '',
        "totalManagedServiceOneTimeFees": ''
      },
      "mspMonthlyServices": {
        "standBtOfficeSpace": '',
        "describe1": '',
        "describe2": '',
        "subTotalMonthlyOneTime": '',
        "miscMonthly": [{
          "monthlyHaasSass": '',
          "qtyAndAmt": '',
          "rateAndPrice": '',
          "oneTime": '',
        }, {
          "monthlyHaasSass": '',
          "qtyAndAmt": '',
          "rateAndPrice": '',
          "oneTime": '',
        }, {
          "monthlyHaasSass": '',
          "qtyAndAmt": '',
          "rateAndPrice": '',
          "oneTime": '',
        }, {
          "monthlyHaasSass": '',
          "qtyAndAmt": '',
          "rateAndPrice": '',
          "oneTime": '',
        }, {
          "monthlyHaasSass": '',
          "qtyAndAmt": '',
          "rateAndPrice": '',
          "oneTime": '',
        }],
        "remoteConnectingHour": '',
        "RemoteConnectOneTime": '',
        "TotalOneTimeEffort": '',
        "endUserDesktopHour": '',
        "EndUserOneTime": ''
      },
      "backupTools": {
        "backupProdTotalPrice": "",
        "backupProdTotalDiscount": "",
        "monthlyPeriod": "",
        "totalBackupMonthlyPrice": "",
        "backupProdSelectedMonth": "",
        "backupProdTable": [{
          "backUpProdName": "pdt 1",
          "quantity": "",
          "price": "",
          "describe": "",
          "monthly": ""
        },
        {
          "backUpProdName": "pdt 2",
          "quantity": "",
          "price": "",
          "describe": "",
          "monthly": ""
        },
        {
          "backUpProdName": "pdt 3",
          "quantity": "",
          "price": "",
          "describe": "",
          "monthly": ""
        }]
      },
      "subtotalItManagementTools": {
        "subTotalUser": "",
        "subTotalDevice": "",
        "subTotalBaseFree": "",
        "subTotalTtlUser": "",
        "subTotalTtlDevice": "",
        "subTotalSubTotal": ""
      },
      "subtotalAdditionalManagementTools": {
        "subTotalUser": "",
        "subTotalDevice": "",
        "subTotalBaseFree": "",
        "subTotalTtlUser": "",
        "subTotalTtlDevice": "",
        "subTotalSubTotal": ""
      },
      "subtotalCyberTools": {
        "subTotalUser": "",
        "subTotalDevice": "",
        "subTotalBaseFree": "",
        "subTotalTtlUser": "",
        "subTotalTtlDevice": "",
        "subTotalSubTotal": ""
      },
      "itManagementTools": [{
        "id": "remoteAccessTool",
        "toolName": "Remote Access Tools",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "ticketingSystem",
        "toolName": "Ticketing System",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "passwordManagementTool",
        "toolName": "Password Management Tool",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "monitoringConnectwise",
        "toolName": "Monitoring (ConnectWise)",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      },
      {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }],
      "additionalManagementTools": [{
        "id": "BfStandard",
        "toolName": "BitDefender - Standard",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "BfUltra",
        "toolName": "BitDefender - Ultra",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "AvananBasic",
        "toolName": "Avanan - Basic",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "AvananAdvanced",
        "toolName": "Avanan - Advanced",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      },
      {
        "id": "ConnectwiseThirdWall",
        "toolName": "Connectwise ThirdWall",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "Duo",
        "toolName": "Duo",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "Auvik",
        "toolName": "Auvik",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "InsuranceRecoveryFee",
        "toolName": "Insurance Recovery Fee",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }],
      "cyberTools": [{
        "id": "CyberWatch",
        "toolName": "CyberWatch",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "CyberLearn",
        "toolName": "CyberLearn",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "NetworkDetective",
        "toolName": "Network Detective",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "NetwrixAuditor",
        "toolName": "Netwrix Auditor",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      },
      {
        "id": "MDR",
        "toolName": " Managed Detection and Response -MDR",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "IdAgentDarkWeb",
        "toolName": "ID Agent Dark Web",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "PenTestTools",
        "toolName": "Pen Test Tools",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "CyberSuiteStandard",
        "toolName": "Cyber Suite Standard",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }, {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      },
      {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      },
      {
        "id": "",
        "toolName": "",
        "incl": false,
        "description":"",
        "user": "",
        "device": "",
        "baseFree": "",
        "ttlUser": "",
        "totalDevice": "",
        "subTotal": ""
      }],
      "additionalUsers": "",
      "additionalDevices": "",
      "TotalMonthlyFee": "",
      "TotalMspToolSets": ""
    },
    "mspForm": {
      "noOfUsers": "",
      "startDate": "",
      "noOfDevices": "",
      "noOfLocations": "",
      "Mailboxes": "",
      "ClientMsaSalutation":"",
      "ClientMsaFirstName":"",
      "ClientMsaLastName":"",
      "ClientAddress": "",
      "ClientCompanyName": "",
      "ClientCode": "",
      "ClientLogo":"",
      "ClientFullName": "",
      "ClientSalutation":"",
      "ClientLastName":"",
      "ClientCity": "",
      "ClientProvince": "",
      "ClientPostal": "",
      "scenarioName": "",
      "nextSowNo":"",
      "userCode":"",
      "userSignature":"",
      "userName":"",
      "longDescription":"",
      "userDesignation":"",
      "totalDashboardOneTime":"",
      "totalDashboardMonthly":"",
      "proposalDate":"",
      "proposedStartDate":"",
      "proposalTitle":"",
      "proposalFileName":"",
      "msaData":{
        "newDate":"",
        "existingDate":"",
        "existingNo":"",
        "fileName":"",
        "revNo":"200425"
      },
      "dashboard": [
        {
          "id":"mspPricingSheet",
          "name": "MSP",
            "overrideDate": "",
            "optionalDescription": "",
            "fileName": "",
            "oneTime": "",
            "monthly": "",
            "sowNo": "",
            "activate":false,
            "published": false
        }, {
          "id":"cyberPricingSheet",
          "name": "CYB",
            "overrideDate": "",
            "optionalDescription": "",
            "fileName": "",
            "oneTime": "",
            "monthly": "",
            "sowNo": "",
            "activate":false,
            "published": false
        }, {
          "id":"cloudPricingSheet",
          "name": "CLD",
            "overrideDate": "",
            "optionalDescription": "",
            "fileName": "",
            "oneTime": "",
            "monthly": "",
            "sowNo": "",
            "activate":false,
            "published": false
        }, {
          "id":"backupDrPricingSheet",
          "name": "BKP",
            "overrideDate": "",
            "optionalDescription": "",
            "fileName": "",
            "oneTime": "",
            "monthly": "",
            "sowNo": "",
            "activate":false,
            "published": false
        }, {
          "id":"hwswHaasSaasSheet",
            "name": "HW",
            "overrideDate": "",
            "optionalDescription": "",
            "fileName": "",
            "oneTime": "",
            "monthly": "",
            "sowNo": "",
            "activate":false,
            "published": false
        }, {
            "id":"projectScreen",
            "name": "PJT",
            "overrideDate": "",
            "optionalDescription": "",
            "fileName": "",
            "oneTime": "",
            "monthly": "",
            "sowNo": "",
            "activate":false,
            "published": false
        }]
    },
    "AllIntronis": [{
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }],
    "AllDatto": [{
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }],
    "BackupDrAllIntronis": [{
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }],
    "BackupDrAllDatto": [{
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }, {
      "device": '',
      "updateOrNew": '',
      "purchasePrice": '',
      "monthlyPrice": ''
    }],
    "MspDattoIntronis": {
      "totalIntronisPrice": "",
      "totalIntronisOneTimePurchase": "",
      "noOfIntronisDevices": [],
      "totalDattoPrice": "",
      "totalDattoOneTimePurchase": "",
      "noOfDattoDevices": [],
    },
    "BackupDrDattoIntronis": {
      "totalIntronisPrice": "",
      "totalIntronisOneTimePurchase": "",
      "noOfIntronisDevices": [],
      "totalDattoPrice": "",
      "totalDattoOneTimePurchase": "",
      "noOfDattoDevices": [],
    },
  }
  dataTable: any;
  ClickedService:any = [];
  goBack: any;
  pjtContractId: any = '';
  bkpContractId: any = '';
  mspContractId: any = '';
  cldContractId: any = '';
  cybContractId: any = '';
  hwContractId: any = '';
  dashboardContractId: any = '';
  showSave: boolean = false;
  showHeaderIcons: boolean = true;
  showEdit: boolean = false;
  showPrint: boolean = false;
  sheetName: any = '';
  TableContent: any;
  UserSignature: any = '';
  StarportLogo: any = '';
  pricelistEntryId: any = '';
  showPricelistIcon: boolean = false;
  publishContract: any = [];
  showPricelistSave: boolean = false;
  uniqueId: any = '';
  ScreenName: any = '';
  constructor(public http: HttpClient, public communicationServ: CommunicationServiceProvider) {
    this.dataTable = JSON.stringify(this.ProposalTable);
  }
  ClearData() {
    localStorage.clear();
    this.ProposalTable = JSON.parse(this.dataTable);
  }
  SaveImportData(data) {
    this.dataTable = JSON.stringify(this.ProposalTable);
  }
  broadcastInfo(data: any) {
    this.communicationServ.getInstance().next(data);
  }

    /** Check inputs are in number **/
isNumeric(evt) {
  var theEvent = evt || window.event;
  var key = theEvent.keyCode || theEvent.which;
  key = String.fromCharCode (key);
  var regex = /[0-9]|\./;
  if ( !regex.test(key) ) {
    theEvent.returnValue = false;
    if(theEvent.preventDefault) theEvent.preventDefault();
  }
}
}



// WEBPACK FOOTER //
// ./src/providers/data-service/data-service.ts